// extracted by mini-css-extract-plugin
module.exports = {"CarfilloIcon":"Support_CarfilloIcon__2txbj"};